import React from 'react';
import Link from 'next/link';
import styles from '../OrderStatus.module.css';
import buttonStyles from '../../../styles/buttons.module.css';
import DetailsBlock from './DetailsBlock';

const ReturnAuthorizationsDetails = (props) => {

  function displayTitle() {
    if (props.returnAuthorizations.length > 0) {
      return 'RA(s) Issued';
    }

    if (props.raEligibility) {
      return 'Start a Return (RA)';
    }
  }

  return (
    <>
      <h2 className={styles.heading}>{displayTitle()}</h2>
      {props.returnAuthorizations.length > 0 && props.returnAuthorizations?.map((ra) => {
        return (
          <DetailsBlock
            ra={ra}
            key={ra.ra_id}
            validators={props.validators}
          />
        );
      })}
      {(props.returnAuthorizations.length === 0 && props.raEligibility) &&
        <div style={{ display: 'flex', alignItems: 'center', paddingTop: 10 }}>
          <Link
            href={{
              pathname: `/orders/${encodeURIComponent(props.order.purchase_id)}/return-authorization`,
              query: { key: props.validators.token }
            }}
          >
            <a target='_blank'>
              <button className={buttonStyles.submitButton}>
                <strong>CREATE RETURN AUTHORIZATION</strong>
              </button>
            </a>
          </Link>
        </div>
      }
    </>
  );
};

export default ReturnAuthorizationsDetails;
